module.exports = __webpack_public_path__ + "images/ds-cm-bg-blog-banner.webp";